import { render, staticRenderFns } from "./SidebarMenu.vue?vue&type=template&id=2311d50b&scoped=true&"
import script from "./SidebarMenu.vue?vue&type=script&lang=js&"
export * from "./SidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./SidebarMenu.vue?vue&type=style&index=0&id=2311d50b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2311d50b",
  null
  
)

export default component.exports